import type { ViewType } from '@lighthouse/core'
import React, { createContext, useContext, useMemo } from 'react'

export type ActionAdderContextValue = {
    viewDsId?: string
    formDsId?: string
    viewType?: ViewType
    isImage?: boolean
}

const ActionAdderContext = createContext<ActionAdderContextValue | null>(null)

export const ActionAdderProvider = ({
    viewDsId,
    formDsId,
    viewType,
    isImage,
    children
}: {
    viewDsId?: string
    formDsId?: string
    viewType?: ViewType
    isImage?: boolean
    children: React.ReactNode
}) => {
    const ctxValue = useMemo(() => ({ viewDsId, formDsId, viewType, isImage }), [formDsId, viewDsId, viewType, isImage])
    return <ActionAdderContext.Provider value={ctxValue}>{children}</ActionAdderContext.Provider>
}

export const useActionAdderContext = () => useContext(ActionAdderContext)

ActionAdderContext.displayName = 'ActionAdderContext'
